import { Link } from 'react-router-dom'
import Container from 'components/common/Container'
import Heading from 'components/common/Heading'
import Navigation from 'components/MainHeader/Navigation'

const MainHeader = () => {
  return (
    <header className="bg-slate-200 sticky top-0 z-30">
        <Container className="flex justify-between items-center">
            <Link to="/">
              <Heading>
                AF
              </Heading>
            </Link>

            <Navigation />
        </Container>
    </header>
  )
}

export default MainHeader